var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"md":"auto"}},[_c('amplify-authenticator',{attrs:{"authConfig":{ signInConfig: { isSignUpDisplayed: false } }}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }